<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>

		<div class="tp-testdiv d-flex">
			<div
				:style="isEmpty && searchTopicTest != '' ? 'width:97%;' : ''"
				:class="
					showTestPreviewStatus ? 'test-child1-div-small' : 'test-child1-div'
				"
			>
				<div class="d-flex align-items-center justify-content-between">
					<div class="d-flex align-items-center" style="width: 30%">
						<div class="pointer">
							<img
								class="pb-1"
								src="../../assets/icons/Reports/bckarrow.svg"
								alt=""
								@click="goTobackpage()"
							/>
						</div>
						<div class="heading-container boxtext ml-3 w-75 mr-3">
							<div class="text-truncate">{{ $route.params.topicName }}</div>
						</div>
					</div>

					<div class="d-flex">
						<div
							class="relativeclass mr-2 switchtext pointer t-test-container"
							@click="testFunction()"
							v-closable="{
								exclude: ['testdropdown'],
								handler: 'hideTestFunction',
							}"
						>
							<div
								class="test-sortcontainer d-flex justify-content-around align-items-center"
							>
								<div class="sorttext">Test Type</div>
								<div class="sortline ml-3"></div>
								<div
									class="d-flex justify-content-between align-items-center pointer"
								>
									<div class="sortordertext ml-3 w-40">
										{{ testCardselected }}
									</div>
									<div class="ml-3">
										<img
											v-if="showtestcard"
											src="../../assets/uparrow.svg"
											alt=""
										/>
										<img v-else src="../../assets/downarrow.svg" alt="" />
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="showtestcard"
							ref="testdropdown"
							class="relativeclass testdashboard"
						>
							<div class="tnt-sortcard jdtypecard p-0">
								<div
									@click="showtestcard = !showtestcard"
									class="xMarkCancel pointer"
								>
									<img src="../../assets/xmark.svg" alt="" />
								</div>
								<b-form-group
									class="sec-mcq-datacard jdtyperadio"
									v-for="i in testTypeOptions"
									:key="i.value"
								>
									<b-form-radio
										class="m-1"
										size="sm"
										v-model="testCardselected"
										:value="i.text"
										@change="changeSort"
									>
										{{ i.text }}
									</b-form-radio>
								</b-form-group>
							</div>
						</div>

						<div
							class="sort-box mr-2 pl-3 pr-3 relativeclass testdashboard switchtext pointer"
							@click="sortFunction()"
							v-closable="{
								exclude: ['sortdropdown'],
								handler: 'hideSortFunction',
							}"
						>
							<div>
								Sort
								<span class="ml-3">
									<img src="../../assets/sorticon.svg" alt=""
								/></span>
							</div>
						</div>
						<div
							v-if="showsortcard"
							ref="sortdropdown"
							class="relativeclass testdashboard"
						>
							<div class="tnt-sortcard p-0 d-flex align-items-center">
								<div
									@click="showsortcard = !showsortcard"
									class="xMarkCancel pointer z-10"
								>
									<img src="../../assets/xmark.svg" alt="" />
								</div>
								<b-form-group class="sec-mcq-datacard">
									<b-form-radio
										class="sort-radio"
										v-for="(sort, index) in sort_options"
										:key="index"
										v-model="sort_selected"
										@change="changeSort"
										:value="sort.value"
									>
										{{ sort.text }}
									</b-form-radio>
								</b-form-group>
							</div>
						</div>

						<div
							class="switchtext pr-3 relativeclass pointer filter-box"
							@click="filterFunction()"
							v-closable="{
								exclude: ['filterdropdown'],
								handler: 'hideFilterFunction',
							}"
						>
							<div class="ml-3 d-flex">
								Filter
								<div class="ml-2 d-flex relativeclass">
									<span><img src="../../assets/filtericon.svg" alt="" /> </span>
									<div class="qb-filter-count" v-if="filtercount != 0">
										{{ filtercount }}
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="showfiltercard"
							ref="filterdropdown"
							class="relativeclass"
						>
							<div class="tnt-filtercard-test d-flex align-items-center">
								<div>
									<div
										@click="showfiltercard = !showfiltercard"
										class="xMarkCancel pointer"
									>
										<img src="../../assets/xmark.svg" alt="" />
									</div>
									<div>
										<div class="topDiv mt-3">
											<label class="fieldsetStyle">Sections </label>
											<b-form-input
												class="filterinputField"
												id="input-1"
												type="number"
												min="0"
												max="999"
												@keypress="avoidLetterE"
												v-model="filter.section"
												placeholder="Enter Sections"
											></b-form-input>
										</div>
									</div>
									<div class="topicfilterinnercard mt-3">
										<div class="d-flex">
											<span style="color: #545454">Public Availability </span>
											<b-form-radio-group
												class="ml-3"
												:options="options"
												v-model="filter.publicAvailability"
												value-field="item"
												text-field="name"
												disabled-field="notEnabled"
												size="sm"
											></b-form-radio-group>
										</div>
									</div>
									<div
										class="d-flex align-items-end justify-content-between mt-3"
									>
										<div
											class="clearfilter pointer"
											:class="
												filter.publicAvailability === '' &&
												filter.section.toString().length === 0
													? filtercount == 0
														? 'disabled-text'
														: 'pointer'
													: 'pointer'
											"
											@click="handleFilterClick"
										>
											Clear Filter
										</div>
										<div>
											<b-button
												class="addbtn"
												:disabled="clearFilterclass"
												@click="applyfilter()"
											>
												Apply
											</b-button>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="d-flex switchtext mr-3 mt-1 pointer">
							<div class="d-flex switchParent ml-2">
								<div
									v-b-popover.hover.top="'Grid View'"
									class="switchChild"
									@click="
										LoaderStatus == true ? '' : saveToggleView(),
											resetPagination()
									"
									:class="{
										activeSwitchLeft: !switchviews,
										notActiveSwitchLeft: switchviews,
									}"
								>
									<img src="../../assets/filtersorticon.svg" alt="" />
								</div>
								<div
									v-b-popover.hover.top="'List View'"
									class="switchChild"
									@click="
										LoaderStatus == true ? '' : saveToggleView(),
											resetPagination()
									"
									:class="{
										activeSwitchRight: switchviews,
										notActiveSwitchRight: !switchviews,
									}"
								>
									<img src="../../assets/rightfilterwhite.svg" alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<template v-if="isEmpty">
					<div class="cl-testcontainer mr-2" id="top1">
						<div
							class="d-flex flex-column align-items-center justify-content-center h-100"
						>
							<div>
								<img src="../../assets/searchnotfound.svg" alt="" />
							</div>
							<div v-if="searchTopicTest != '' && searchTopicTest != 'Loader'">
								<span class="searchnotfound"
									>No matching results for
									<span class="searchtext"> "{{ searchTopicTest }}" </span>
									.</span
								>
							</div>
							<div v-else>
								<span class="searchnotfound">No data found.</span>
							</div>
						</div>
					</div>
				</template>

				<template v-else>
					<div
						:class="
							isEmpty && searchTopicTest != ''
								? 'cl-testcontainer mr-2 w-100'
								: 'cl-testcontainer mr-2'
						"
						id="top1"
					>
						<div class="d-flex justify-content-end" ref="dropdown">
							<b-button
								class="addbtn d-flex align-items-center"
								@click="toggleDropdown"
								v-if="
									roles.includes('PUSH_TEST') &&
										testCardselected != 'Inactive' &&
										!showAddNewCardWhenNoData
								"
							>
								<img src="../../assets/plusicon.svg" alt="" class="mr-2" />
								<span class="">Add Test</span>
							</b-button>

							<div v-if="showtestaddoptions" class="test-optionscard">
								<div
									v-b-modal.testNameModal
									@click="clearTestModalData(), $v.$reset()"
									class="d-flex align-items-center"
								>
									<img
										src="../../assets/icons/Archivetest/greyplus.svg"
										alt=""
										class="mr-2 mb-1"
									/>
									<span class="test-options-text mb-1">Add New</span>
								</div>
								<div
									v-if="roles.includes('CLONE_TEST')"
									class="mt-2 d-flex align-items-center pointer"
									@click="
										(search = ''), (selectedTests = []), archivetestmodal()
									"
								>
									<img
										src="../../assets/icons/Archivetest/archivetagtest.svg"
										alt=""
										class="mr-2 mb-1"
									/>
									<span class="test-options-text mb-1">Clone</span>
								</div>
							</div>
						</div>

						<div>
							<div
								class="addtopicbox d-flex justify-content-center align-items-center"
								@click="clearTestModalData(), $v.$reset()"
								v-b-modal.testNameModal
								v-if="
									showAddNewCardWhenNoData &&
										roles.includes('PUSH_TEST') &&
										testCardselected != 'Inactive' &&
										searchTopicTest == '' &&
										LoaderStatus == false
								"
							>
								<div class="text-center pointer">
									<img src="../../assets/addsecicon.svg" alt="" />
									<div class="addtopictext mt-2">Add New Test</div>
								</div>
							</div>
						</div>

						<div
							class="emptycard-design"
							v-if="
								showAddNewCardWhenNoData &&
									roles.includes('PUSH_TEST') &&
									testCardselected != 'Inactive' &&
									searchTopicTest == '' &&
									LoaderStatus == false
							"
						>
							<span>To begin creating a new test</span>
							<span>Click on "Add New Test" button</span>
						</div>
						<div
							class="text-center"
							v-if="testCardselected == 'Inactive' && showAddNewCardWhenNoData"
						>
							<img src="../../assets/nodata.svg" alt="No data found" />
						</div>
						<template v-if="!switchviews">
							<div
								v-if="!showAddNewCardWhenNoData"
								@scroll="onScroll"
								class="d-flex flex-wrap topic-cards-container"
								:style="
									testCardselected == 'Inactive'
										? 'height:calc(100vh - 181px);'
										: ''
								"
							>
								<div>
									<transition-group
										name="cell"
										class="d-flex flex-wrap mt-3"
										tag="div"
									>
										<div
											v-for="(i, index) in testState"
											:key="i.testID"
											class="new-tp-pading"
										>
											<TestCard
												@filterCard="
													(showfiltercard = false),
														(showsortcard = false),
														(showtestcard = false)
												"
												:showindex="index"
												:selectFirstCard="selectFirstCard"
												:testDetails="i"
												:type="$route.query.type"
												:sort="$route.query.sort"
												:ttype="$route.query.ttype"
												:tsort="$route.query.tsort"
												@test-card-option="testcardoptions"
												@card-close="changevalue"
												@resetPagination="resetPagination"
												@lengthofTotalTopicsWhenedidted="
													lengthofTotalTopicsWhenedidted
												"
											/>
										</div>
									</transition-group>
								</div>
								<div
									style="margin: auto"
									v-if="showLoader"
									class="d-flex justify-content-center mb-3"
								>
									<b-spinner label="Loading..."></b-spinner>
								</div>
							</div>
						</template>
						<template v-if="switchviews">
							<div
								@scroll="onScroll"
								class="mt-3 topic-list-card-container"
								:style="
									testCardselected == 'Inactive'
										? 'height:calc(100vh - 181px);'
										: ''
								"
							>
								<transition-group name="flip-list" tag="div" class="mr-1">
									<div
										v-for="(i, index) in testState"
										:key="i.testID"
										:class="index != testState.length - 1 ? 'mb-3' : ''"
									>
										<TestCardGrid
											@filterCard="
												(showfiltercard = false),
													(showsortcard = false),
													(showtestcard = false)
											"
											:showindex="index"
											:selectFirstCard="selectFirstCard"
											:testDetails="i"
											:type="$route.query.type"
											:sort="$route.query.sort"
											:ttype="$route.query.ttype"
											:tsort="$route.query.tsort"
											@test-card-option="testcardoptions"
											@card-close="changevalue"
											@resetPagination="resetPagination"
											@lengthofTotalTopicsWhenedidted="
												lengthofTotalTopicsWhenedidted
											"
										/>
									</div>
								</transition-group>
								<div
									style="margin: auto"
									v-if="showLoader"
									class="d-flex justify-content-center mb-3"
								>
									<b-spinner label="Loading..."></b-spinner>
								</div>
							</div>
						</template>
					</div>
				</template>
			</div>
			<div
				v-if="!isEmpty || searchTopicTest == ''"
				id="top1config"
				class="ml-2 relativeclass"
				:class="{
					tpsubchilddiv: !showTestPreviewStatus,
					tpsubchilddivppreview: showTestPreviewStatus,
				}"
			>
				<div
					:class="{
						'h-100 d-flex align-items-center justify-content-center':
							!showTestPreviewStatus &&
							testConfigStatus &&
							!selectFirstCard.active,
					}"
				>
					<template v-if="showTestPreviewStatus">
						<TestPreview :type="'preview'" />
					</template>
					<template v-if="testConfigStatus && selectFirstCard.active">
						<SideTestConfig />
					</template>
					<template v-if="testState.length != 0">
						<div
							v-if="testConfigStatus == false && showTestPreviewStatus == false"
							class="configpreviewgraphval d-flex align-items-center justify-content-center flex-column"
						>
							<div
								class="text-center mt-5"
								v-if="testCardselected != 'Inactive'"
							>
								<div>
									<img
										src="../../assets/icons/testconfig/Config-icon-testPage.svg"
										alt=""
									/>
								</div>
								<div class="emptyillusttext mt-3">
									Click
									<strong> "Configuration icon"</strong>
									to view groups/individual
								</div>
							</div>
							<div
								v-if="testCardselected != 'Inactive'"
								class="d-flex justify-content-center align-items-center testconfig-tp-text mt-5"
							>
								OR
							</div>
							<div class="text-center mt-5">
								<div>
									<img src="../../assets/icons/test.svg" alt="" />
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>

			<b-modal
				id="testNameModal"
				centered
				hide-footer
				hide-header
				size="lg"
				no-close-on-backdrop
			>
				<header
					class="d-flex align-items-center justify-content-between viewcon-border-bottom head"
				>
					<div
						class="font-lato fw-500 fs-18 color-black d-flex align-items-center gap-2"
					>
						Add Test
					</div>
					<div @click="closetestmodal()">
						<img
							class="rotate-on-hover pointer"
							src="../../assets/common-icons/blue-cross.svg"
							alt=""
						/>
					</div>
				</header>
				<div class="p-3">
					<b-row>
						<b-col>
							<div class="topDiv mt-3">
								<label class="viewcon-label"
									>Test Name &nbsp;<span class="asterik">*</span></label
								>
								<b-form-input
									v-on:keyup.enter="addtest()"
									class="viewcon-inputField"
									id="input-1"
									placeholder="Enter here"
									:class="{ error: $v.name.$error }"
									v-model.trim="$v.name.$model"
									type="text"
									autofocus
								></b-form-input>
								<div
									style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
									v-if="$v.name.$dirty && !$v.name.required"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>

								<div
									style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
									v-if="!$v.name.maxLength && $v.name.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Should not exceed 128 characters',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>

								<div
									style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
									v-if="!$v.name.alpha && $v.name.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Please Enter a Valid Test Name',
									}"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
						</b-col>
						<!-- <b-col>
							<div class="d-flex mt-3">
								<span class="viewcon-option-clr"
									>Public Availability <span class="asterik">*</span></span
								>
								<b-form-radio-group
									class="ml-3"
									:options="options"
									v-model="publicAvailability"
									value-field="item"
									text-field="name"
									disabled-field="notEnabled"
									size="sm"
									@change="
										() => {
											if (publicAvailability == false) {
												addAssessLb = false;
												selectedLbOption = '';
											}
										}
									"
								></b-form-radio-group>
							</div>
						</b-col> -->
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<div class="topDiv mt-3">
								<span class="viewcon-label"
									>Category<span class="asterik">*</span></span
								>
								<div
									ref="category-dropdown-button"
									@click="openCategoryDropdown = !openCategoryDropdown"
									class="viewcon-select d-flex justify-content-between relativeclass"
									:class="{ error: $v.selectedCategory.$error }"
								>
									<span
										:class="
											selectedCategory == '' || selectedCategory == null
												? ''
												: 'viewcon-option-clr'
										"
										class="text-truncate"
										>{{
											selectedCategory == "" || selectedCategory == null
												? "Select Category"
												: categories.find((c) => c.value == selectedCategory)
														.text
										}}</span
									>
									<span v-if="!openCategoryDropdown"
										><img src="../../assets/carrotdown.svg" alt="" class="mr-1"
									/></span>
									<span v-else
										><img src="../../assets/uparrow.svg" alt="" class="mr-1"
									/></span>
								</div>
								<div
									v-if="openCategoryDropdown"
									class="bct-checkboxcontainer pointer"
									ref="category-dropdown"
									v-closable="{
										exclude: ['category-dropdown-button', 'category-dropdown'],
										handler: 'closeCategoryDropdown',
									}"
								>
									<b-form-group class="qb-dd-group-ct">
										<b-form-radio-group
											class="bct-checboxtext radio-drp-dwn"
											:options="categories"
											v-model="selectedCategory"
											@change="closeCategoryDropdown"
											buttons
											stacked
										>
										</b-form-radio-group>
									</b-form-group>
								</div>
							</div>
						</b-col>
						<b-col>
							<div class="topDiv mt-3">
								<label class="viewcon-label"
									>Sub Category<span class="asterik">*</span></label
								>
								<div
									ref="sub-category-dropdown-button"
									@click="
										selectedCategory &&
											(openSubCategoryDropdown = !openSubCategoryDropdown)
									"
									class="viewcon-select d-flex justify-content-between relativeclass"
									:class="{
										'disabled-text test-disable-color':
											selectedCategory == null,
										error: $v.selectedSubCategory.$error,
									}"
								>
									<span
										:class="
											selectedSubCategory == '' || selectedSubCategory == null
												? ''
												: 'viewcon-option-clr'
										"
										class="text-truncate"
										>{{
											selectedSubCategory == "" || selectedSubCategory == null
												? "Select Sub Category"
												: subCategories[selectedCategory].find(
														(c) => c.value == selectedSubCategory
												  ).text
										}}</span
									>
									<span v-if="!openSubCategoryDropdown"
										><img src="../../assets/carrotdown.svg" alt="" class="mr-1"
									/></span>
									<span v-else
										><img src="../../assets/uparrow.svg" alt="" class="mr-1"
									/></span>
								</div>
								<div
									v-if="openSubCategoryDropdown"
									class="bct-checkboxcontainer pointer"
									ref="sub-category-dropdown"
									v-closable="{
										exclude: [
											'sub-category-dropdown-button',
											'sub-category-dropdown',
										],
										handler: 'closeSubCategoryDropdown',
									}"
								>
									<b-form-group class="qb-dd-group-ct">
										<b-form-radio-group
											class="bct-checboxtext radio-drp-dwn"
											:options="subCategories[selectedCategory]"
											v-model="selectedSubCategory"
											@change="closeSubCategoryDropdown"
											buttons
											stacked
										>
										</b-form-radio-group>
									</b-form-group>
								</div>
							</div>
						</b-col>
					</b-row>
					<div
						class="pricing-container mt-3"
						v-if="leaderboardAdminAccess && publicAvailability"
					>
						<b-row class="access-switch mx-0 flex-column">
							<div class="d-flex align-items-baseline ">
								<span class="fw-500 fs-16 color-black mr-2">Set Pricing</span>
								<b-form-checkbox
									name="role-check-button"
									class=""
									switch
									v-model="setPricing"
									@change="hideshowPricingDetails"
								>
								</b-form-checkbox>
							</div>
							<hr style="border-top:1px solid #D0D5DD80;" class="my-2 w-100" />
							<div class="d-flex align-items-center">
								<b-col class="pl-0">
									<div class="topDiv mt-3">
										<label class="viewcon-label" v-if="setPricing"
											>List Price(Rs.) &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="viewcon-inputField"
											placeholder="List Price"
											v-model.number="$v.listPrice.$model"
											:class="{
												error: $v.listPrice.$error,
												'test-disable-color': !setPricing,
											}"
											:disabled="!setPricing"
											type="number"
										></b-form-input>
										<div
											style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
											v-if="$v.listPrice.$dirty && !$v.listPrice.required"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>

										<div
											style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
											v-if="$v.listPrice.$dirty && !$v.listPrice.between"
											v-b-popover.hover.top.v-danger="{
												content: 'Must be between 0 and 100000',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>

										<div
											style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
											v-if="
												$v.listPrice.$dirty && !$v.listPrice.maxFiveDecimals
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Must have at most 5 decimal places',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col class="pr-0">
									<div class="topDiv mt-3">
										<label class="viewcon-label" v-if="setPricing"
											>Discount(Rs.)</label
										>
										<b-form-input
											class="viewcon-inputField"
											placeholder="Discount"
											v-model.number="$v.discount.$model"
											:class="{
												error: $v.discount.$error,
												'test-disable-color': !setPricing,
											}"
											:disabled="!setPricing"
											type="number"
										></b-form-input>

										<div
											style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
											v-if="
												$v.discount.$dirty && !$v.discount.notGreaterThanList
											"
											v-b-popover.hover.top.v-danger="{
												content:
													'Discount price cannot exceed or be equal than list price',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
											v-if="!$v.discount.minValue"
											v-b-popover.hover.top.v-danger="{
												content: 'Discount Price Cannot be negative number',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="  position: absolute;
                  top: 40px;
                 "
											class="fw-500 fs-10 color-7a7a7a fam-lato position-absolute"
										>
											Discount Price should be lesser than List price
										</div>
										<div
											style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
											v-if="$v.discount.$dirty && !$v.discount.maxFiveDecimals"
											v-b-popover.hover.top.v-danger="{
												content: 'Must have at most 5 decimal places',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</div>
						</b-row>
						<template v-if="setPricing">
							<section class="mt-3">
								<div class="d-flex align-items-center justify-content-between">
									<div class="fw-500 font-lato fs-14 color-344054">
										List Price
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										₹ {{ listPrice || 0 }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="fw-500 font-lato fs-14 color-344054">
										Discount
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										₹{{ discount || 0 }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="fw-500 font-lato fs-14 color-344054">
										Final Price
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										₹{{ priceAfterDiscount || 0 }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="fw-500 font-lato fs-14 color-344054">
										Payment Gateway Charges
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										{{ gatewayPercent }}%
									</div>
								</div>
							</section>
							<hr />
							<div
								class="d-flex align-items-center justify-content-between mt-1"
							>
								<div class="fw-600 font-lato fs-14 color-333333">
									Final Amount Receivable
								</div>
								<div class="fw-700 font-mont fs-16 color-333333">
									₹{{ finalReceivable || 0 }}
								</div>
							</div>
						</template>
					</div>
					<b-row
						class="mt-3 access-switch align-items-center"
						v-if="leaderboardAdminAccess && publicAvailability"
					>
						<b-col>
							<b-form-checkbox
								name="role-check-button"
								class="mt-3"
								switch
								v-model="addAssessLb"
								@change="
									() => {
										if (addAssessLb == false) {
											selectedLbOption = '';
										}
									}
								"
							>
								Add Assessment to Leaderboard
							</b-form-checkbox>
						</b-col>
						<b-col>
							<div class="topDiv mt-3">
								<span
									class="viewcon-label"
									style="z-index: 1;"
									v-if="addAssessLb"
									>Leaderboard category<span class="asterik">*</span></span
								>
								<div
									ref="lb-dropdown-button"
									@click="
										addAssessLb == true &&
											(openLeaderBoardDropdown = !openLeaderBoardDropdown)
									"
									class="viewcon-select d-flex justify-content-between relativeclass"
									:class="{
										'disabled-text test-disable-color viewicon-select-disable cursor-disabled':
											addAssessLb == false,
										error: addAssessLb && $v.selectedLbOption.$error,
									}"
								>
									<span
										:class="
											selectedLbOption == '' || selectedLbOption == null
												? ''
												: 'viewcon-option-clr'
										"
										class="text-truncate"
										>{{
											selectedLbOption == "" || selectedLbOption == null
												? "Select Leaderboard Category"
												: leaderBoardoptions.find(
														(c) => c.value == selectedLbOption
												  ).text
										}}</span
									>
									<span v-if="!openLeaderBoardDropdown"
										><img src="../../assets/carrotdown.svg" alt="" class="mr-1"
									/></span>
									<span v-else
										><img src="../../assets/uparrow.svg" alt="" class="mr-1"
									/></span>
								</div>
								<div
									v-if="openLeaderBoardDropdown"
									class="bct-checkboxcontainer pointer"
									ref="lb-dropdown"
									v-closable="{
										exclude: ['lb-dropdown-button', 'lb-dropdown'],
										handler: 'closeLeaderBoardDropdown',
									}"
								>
									<b-form-group class="qb-dd-group-ct">
										<b-form-radio-group
											class="bct-checboxtext radio-drp-dwn"
											:options="leaderBoardoptions"
											v-model="selectedLbOption"
											@change="closeLeaderBoardDropdown"
											buttons
											stacked
										>
										</b-form-radio-group>
									</b-form-group>
								</div>
							</div>
						</b-col>
					</b-row>
					<b-row class="mt-2" style="height: 32px;">
						<b-col v-if="publicAvailability">
							<div class="d-flex mt-3">
								<span class="viewcon-option-clr"
									>Set Configuration: <span class="asterik">*</span></span
								>

								<b-form-radio-group
									class="ml-3"
									v-model="setConfiguration"
									:options="setConfigOptions"
									value-field="item"
									text-field="name"
									size="sm"
								></b-form-radio-group>
							</div>
						</b-col>
					</b-row>

					<div
						v-if="configName != '' && setConfiguration == 'manual'"
						class="d-flex justify-content-between mt-4"
					>
						<div
							class="selected-config d-flex align-items-center justify-content-between mr-4"
						>
							<div class="color-mainblue">
								{{ configName }}
							</div>
							<div class="color-green">Configured</div>
						</div>
						<div
							@click="showViewConfigModal = true"
							class="d-flex align-items-center gap-1 color-mainblue pointer"
						>
							<img
								src="../../assets/common-icons/changeconfig.svg"
								alt=""
							/>Change
						</div>
					</div>
					<div
						class="d-flex mt-3"
						:class="
							testState.length == 0
								? 'justify-content-between'
								: 'justify-content-end'
						"
					>
						<div
							class="mt-2 d-flex align-items-center pointer"
							@click="(search = ''), (selectedTests = []), archivetestmodal()"
							v-if="testState.length == 0 && roles.includes('CLONE_TEST')"
						>
							<img
								src="../../assets/icons/Archivetest/archivetagtest.svg"
								alt=""
								class="mr-2 mb-1"
							/>
							<span class="test-options-text mb-1">Clone Test</span>
						</div>
						<b-button
							class="new-addBtn"
							@click="
								setConfiguration == 'auto' ||
								configName != '' ||
								publicAvailability == false
									? addtest()
									: openViewAllConfigModal()
							"
							v-if="updateData == null"
						>
							{{
								setConfiguration == "auto" ||
								configName != "" ||
								publicAvailability == false
									? "Save"
									: "Next"
							}}
						</b-button>

						<b-button
							class="new-addBtn"
							@click="
								setConfiguration == 'auto' ||
								configName != '' ||
								publicAvailability == false
									? makeactive()
									: openViewAllConfigModal()
							"
							v-else
						>
							{{
								setConfiguration == "auto" ||
								configName != "" ||
								publicAvailability == false
									? "Save"
									: "Next"
							}}
						</b-button>
					</div>
				</div>
			</b-modal>
			<b-modal id="testsamename" centered hide-footer hide-header>
				<div
					class="modalheading d-flex align-items-center justify-content-between"
				>
					Caution
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div @click="$bvModal.hide('testsamename')" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<hr />
				<div class="mt-3">
					<div class="testsamename-modal-text mt-2">
						<img src="../../assets/noteicon.svg" alt="" />

						<span class="ml-2"
							>Test
							<span class="testsamename-test"> "{{ name }}" </span>
							already exists in the inactive list.
						</span>
					</div>
					<div class="testsamename-modal-text mt-3 mb-3">
						Test with the name "{{ name }}" already exists. "Would you like to
						activate the existing test or add a new one?"
					</div>
					<b-form-radio-group
						class="test-caution-option test-activate-options-text"
						:options="updatedataoptions"
						value-field="item"
						text-field="name"
						disabled-field="notEnabled"
						v-model="updateData"
					></b-form-radio-group>

					<div class="d-flex align-items-center justify-content-end mt-3">
						<b-button
							class="addbtn pl-3 pr-3"
							@click="gotoparticularpage"
							:disabled="updateData == null"
						>
							Next
						</b-button>
					</div>
				</div>
			</b-modal>

			<b-modal id="archivetestmodal" centered hide-footer hide-header size="lg">
				<div
					class="modalheading d-flex align-items-center justify-content-between modal-text"
				>
					All Tests
				</div>
				<div @click="$bvModal.hide('archivetestmodal')" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>

				<hr />
				<div class="tabbed mt-3 position-relative" style="margin-bottom: 0px">
					<b-overlay :show="showTestSpinner" rounded="sm">
						<b-tabs>
							<b-tab
								@click="
									(testType = 1),
										(currentTestPage = 1),
										(selectedTests = []),
										archivetestmodal()
								"
							>
								<template #title>
									<div class="d-flex">
										<div class="ptab-name text-capitalize relativeclass">
											Active Tests
										</div>
									</div>
								</template>
								<div class="d-flex align-items-center mt-3">
									<div style="width: 85%" class="position-relative search-bar">
										<span class="search-pos">
											<img src="../../assets/searchicon.svg" alt=""
										/></span>
										<b-form-input
											class="search-input"
											type="search"
											placeholder="Search here"
											@keyup="archivetestmodal"
											@input="archivetestmodal"
											v-model="search"
										></b-form-input>
									</div>
									<div style="width: 15%" class="ml-2">
										<b-button
											class="addbtn pl-3 pr-3"
											@click="tagTest(), (showTestSpinner = true)"
											:disabled="selectedTests.length == 0"
										>
											Tag Test
										</b-button>
									</div>
								</div>

								<div class="archivetestcheckbox mt-3">
									<b-form-checkbox
										v-model="selectall"
										@change="selectAll()"
										v-if="tests.length > 0"
									>
										Select all Tests
									</b-form-checkbox>
								</div>
								<div class="position-relative">
									<div
										style="height: calc(100vh - 375px); overflow-y: auto;overflow-x: hidden;"
									>
										<div
											class="no-archivetest-list-cards add-access-user-head d-flex align-items-center justify-content-center m-2 text-break p-2 flex-column"
											v-if="tests.length == 0 && search != ''"
										>
											<div class="h-50 w-50">
												<img
													class="h-100 w-100"
													src="../../assets/searchnotfound.svg"
													alt=""
												/>
											</div>
											No matching results for "{{ search }}"
										</div>

										<div
											class="archivetest-list-cards d-flex m-2 mt-3 position-relative"
											style="height: 60px"
											v-for="test in tests"
											:key="test.testID"
										>
											<div
												style="top: -10px;"
												class="position-absolute tc-lb-badge d-flex align-items-center"
												v-if="leaderboardAdminAccess && test.leaderboard"
											>
												<img src="@/assets/newimgs/leaderboard.svg" alt="" />
												<span class="font-mont fw-500 fs-12 color-white ml-1"
													>Featured in Leaderboard</span
												>
											</div>
											<div
												class="archivetestcheckbox d-flex pt-2 pl-2 align-items-baseline"
												style="width: 5%"
											>
												<b-form-checkbox
													class="mr-1"
													v-model="selectedTests"
													:value="{
														testID: test.testID,
														name: test.testName,
														publicAvailability: test.publicAvailability,
														numberOfSections: test.numberOfSections,
														candidateCount: test.candidateCount,
														marks: test.marks,
														categoryID: test.categoryID,
														subCategoryID: test.subCategoryID,
													}"
													@change="deselect()"
												>
												</b-form-checkbox>
											</div>
											<div style="width: 95%" class="d-flex align-items-center">
												<div style="width: 60%">
													<div class="archivelist-topictxt text-truncate">
														{{ test.topicName }}
													</div>
													<div class="archivelist-testtxt mt-1 text-truncate">
														{{ test.testName }}
													</div>
												</div>
												<div style="width: 15%">
													<div class="d-flex align-items-center">
														<span class="archivesections-txt">Sections</span>
														<span class="archivegreennumbertext ml-2">{{
															test.numberOfSections
														}}</span>
													</div>
												</div>

												<div style="width: 15%" class="ml-3">
													<div class="d-flex align-items-center">
														<span class="archivesections-txt">Marks</span>
														<span class="archiveyellownumbertext ml-2">{{
															test.marks
														}}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</b-tab>
							<b-tab
								@click="
									(testType = 0),
										(currentTestPage = 1),
										(selectedTests = []),
										archivetestmodal()
								"
							>
								<template #title>
									<div class="d-flex">
										<div class="ptab-name text-capitalize relativeclass">
											Inactive Tests
										</div>
									</div>
								</template>
								<div class="d-flex align-items-center mt-3">
									<div style="width: 85%" class="position-relative search-bar">
										<span class="search-pos">
											<img src="../../assets/searchicon.svg" alt=""
										/></span>
										<b-form-input
											class="search-input"
											type="search"
											placeholder="Search here"
											@keyup="archivetestmodal"
											@input="archivetestmodal"
											v-model="search"
										></b-form-input>
									</div>
									<div style="width: 15%" class="ml-2">
										<b-button
											class="addbtn pl-3 pr-3"
											@click="tagTest()"
											:disabled="selectedTests.length == 0"
										>
											Tag Test
										</b-button>
									</div>
								</div>

								<div class="archivetestcheckbox mt-3">
									<b-form-checkbox
										v-model="selectall"
										@change="selectAll()"
										v-if="tests.length > 0"
									>
										Select all Test
									</b-form-checkbox>
								</div>
								<div class="position-relative">
									<div style="height: calc(100vh - 375px); overflow-y: auto">
										<div
											class="no-archivetest-list-cards add-access-user-head d-flex align-items-center justify-content-center m-2 text-break p-2 flex-column"
											v-if="tests.length == 0 && search != ''"
										>
											<div class="h-50 w-50">
												<img
													class="h-100 w-100"
													src="../../assets/searchnotfound.svg"
													alt=""
												/>
											</div>
											No matching results for "{{ search }}"
										</div>

										<div
											class="archivetest-list-cards d-flex m-2 mt-3 position-relative"
											style="height: 60px"
											v-for="test in tests"
											:key="test.testID"
										>
											<div
												style="top: -10px;"
												class="position-absolute tc-lb-badge d-flex align-items-center"
												v-if="leaderboardAdminAccess && test.leaderboard"
											>
												<img src="@/assets/newimgs/leaderboard.svg" alt="" />
												<span class="font-mont fw-500 fs-12 color-white ml-1"
													>Featured in Leaderboard</span
												>
											</div>
											<div
												class="archivetestcheckbox d-flex pt-2 pl-2 align-items-baseline"
												style="width: 5%"
											>
												<b-form-checkbox
													class="mr-1"
													v-model="selectedTests"
													:value="{
														testID: test.testID,
														name: test.testName,
														publicAvailability: test.publicAvailability,
														numberOfSections: test.numberOfSections,
														candidateCount: test.candidateCount,
														marks: test.marks,
													}"
												>
												</b-form-checkbox>
											</div>
											<div style="width: 95%" class="d-flex align-items-center">
												<div style="width: 60%">
													<div class="archivelist-topictxt text-truncate">
														{{ test.topicName }}
													</div>
													<div class="archivelist-testtxt mt-1 text-truncate">
														{{ test.testName }}
													</div>
												</div>
												<div style="width: 15%">
													<div class="d-flex align-items-center">
														<span class="archivesections-txt">Sections</span>
														<span class="archivegreennumbertext ml-2">{{
															test.numberOfSections
														}}</span>
													</div>
												</div>

												<div style="width: 15%" class="ml-3">
													<div class="d-flex align-items-center">
														<span class="archivesections-txt">Marks</span>
														<span class="archiveyellownumbertext ml-2">{{
															test.marks
														}}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</b-tab>
							<div
								class="tests-paginaTion d-flex justify-content-between align-items-center"
							>
								<div style="width: 37%" class="d-flex">
									<span class="qb-gotopage-text p-1">Go to page</span>
									<b-form-input
										type="text"
										class="qb-pagination-num mr-1"
										v-model="goToTestPage"
										@keyup.enter="
											goToTestPage === null ||
											goToTestPage == '' ||
											iscontainsNumber
												? ''
												: goToTopicPageNo(goToTestPage)
										"
									></b-form-input>
									<b-button
										class="qb-pagination-addbtn"
										@click="goToTopicPageNo(goToTestPage)"
										:disabled="
											goToTestPage === null ||
												goToTestPage == '' ||
												iscontainsNumber
										"
									>
										<span
											><img src="../../assets/whiterightarrow.svg" alt=""
										/></span>
									</b-button>
								</div>
								<div
									style="width: 38%"
									class="pagination d-flex justify-content-center"
								>
									<b-pagination
										v-model.number="currentTestPage"
										@input="archivetestmodal()"
										:total-rows="totalTest"
										:per-page="testCount"
										align="center"
										first-number
										last-number
									>
										<template #prev-text
											><span
												><img src="../../assets/leftvector.svg" alt="" /> </span
										></template>
										<template #next-text
											><span
												><img src="../../assets/rightarrow.svg" alt=""/></span
										></template>
									</b-pagination>
								</div>
								<div
									style="width: 25%"
									class="qb-gotopage-text d-flex justify-content-end"
								>
									Results : <span>{{ testPageStart }}</span> -
									{{ testPageEnd }} of
									{{ totalTest }}
									<!-- {{Math.ceil(allQuestions.total / this.question_count)}} -->
								</div>
							</div>
						</b-tabs>
					</b-overlay>
				</div>
			</b-modal>
			<b-modal id="inactivetests" centered hide-footer hide-header size="lg">
				<div
					class="modalheading d-flex align-items-center justify-content-between modal-text"
				>
					Caution
				</div>
				<div @click="$bvModal.hide('inactivetests')" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>

				<hr />

				<div class="mt-3">
					<div class="testsamename-modal-text mt-2">
						<img src="../../assets/noteicon.svg" alt="" />

						<span class="ml-2 inactivetopicname-topic"
							>The test
							<span class="testsamename-test"> " {{ name }}" </span>
							with the same test name already exists in the inactive list.
						</span>
					</div>
					<div class="inactivetopicname-text mt-3 ml-2">
						Please confirm the test that you want to activate based on other
						details.
					</div>
				</div>

				<div class="testdata-size mt-3">
					<div
						class="d-flex align-items-center"
						v-for="i in activetest"
						:key="i.testID"
						@click="selected(), (selectedtest = i)"
						:class="
							selectedtest.testID == i.testID
								? 'inactive-selected-box'
								: 'inactivecust-detail-box'
						"
					>
						<div style="width: 100%" class="d-flex pointer">
							<div class="d-flex flex-column" style="width: 55%">
								<div class="tp-text tp-cardhead ml-1">
									{{ i.name }}
								</div>
								<div>
									<span
										:class="
											i.difficultyLevel == 'Easy'
												? 'pinktext'
												: i.difficultyLevel == '--'
												? 'disabletext'
												: 'greytext'
										"
										>Easy / </span
									><span
										:class="
											i.difficultyLevel == 'Medium'
												? 'pinktext'
												: i.difficultyLevel == '--'
												? 'disabletext'
												: 'greytext'
										"
										>Medium </span
									><span
										:class="
											i.difficultyLevel == 'Difficult'
												? 'pinktext'
												: i.difficultyLevel == '--'
												? 'disabletext'
												: 'greytext'
										"
										>/ Difficult</span
									>
								</div>
							</div>
							<div
								class="d-flex flex-column align-items-center"
								style="width: 15%"
							>
								<span class="tp-cardhead">Sections</span>
								<span v-if="i.numberOfSections < 10" class="greennumbertext"
									>0{{ i.numberOfSections }}</span
								>
								<span v-else class="greennumbertext">{{
									i.numberOfSections
								}}</span>
							</div>
							<div
								style="width: 15%"
								class="d-flex ml-3 flex-column align-items-center"
							>
								<span class="tp-cardhead">Candidates</span>
								<span v-if="i.candidateCount < 10" class="bluenumbertext"
									>0{{ i.candidateCount }}</span
								>
								<span v-else class="bluenumbertext">{{
									i.candidateCount
								}}</span>
							</div>
							<div
								class="d-flex flex-column align-items-center"
								style="width: 15%"
							>
								<span class="tp-cardhead">Marks</span>
								<span v-if="i.marks < 10" class="yellownumbertext"
									>0{{ i.marks }}</span
								>
								<span v-else class="yellownumbertext">{{ i.marks }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="ml-3 d-flex justify-content-end">
					<b-button
						v-if="cardSelectedForActivate === false"
						class="addbtn pl-3 pr-3 disabled"
						>Activate Test</b-button
					>
					<b-button
						v-if="cardSelectedForActivate === true"
						class="addbtn pl-3 pr-3"
						@click="gotoparticulartestdetails()"
						>Activate Test</b-button
					>
				</div>
			</b-modal>
			<b-modal id="taggedfailtest" centered hide-footer hide-header size="lg">
				<div class="modalheading d-flex align-items-center modal-text">
					<div class="pointer">
						<img
							class="pb-1 mr-2"
							src="../../assets/icons/Reports/bckarrow.svg"
							alt=""
							v-b-modal.archivetestmodal
						/>
					</div>
					Failed to Tag Tests
				</div>
				<div @click="$bvModal.hide('taggedfailtest')" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>

				<hr />
				<div class="mt-3">
					<div class="taggedtest-text">
						<img src="../../assets/noteicon.svg" class="mr-2" alt="" />
						<span v-if="failedTests.length == 1">
							Please modify the test name and add it, as this test already
							exists within topic list.
						</span>
						<span v-else>
							Please modify the test name and add it, as these test already
							exists within topic list.
						</span>
					</div>
					<div class="position-relative">
						<div
							style="
                min-height: 200px;
                max-height: calc(100vh - 335px);
                overflow-y: auto;
              "
						>
							<div
								class="archivetest-list-cards d-flex m-2"
								style="height: 72px"
								v-for="(i, index) in failedTests"
								:key="index"
							>
								<div
									class="archivetestcheckbox d-flex pt-4 pl-2 align-items-baseline"
									style="width: 5%"
								>
									<img
										src="../../assets/icons/Archivetest/greycheck.svg"
										alt=""
									/>
								</div>
								<div style="width: 95%" class="d-flex align-items-center">
									<div style="width: 60%">
										<div class="archivelist-topictxt">{{ i.topicName }}</div>
										<!-- before editing test name-->
										<div
											v-if="i.edit == false"
											class="d-flex align-items-center mt-1"
										>
											<div class="archivelist-testtxt">
												<span
													v-b-popover.hover.top="i.name"
													class="d-inline-block text-truncate"
													style="max-width: 100%"
												>
													{{ i.name }}
												</span>
											</div>
											<div class="ml-3">
												<img
													v-b-popover.hover.top="'Edit'"
													src="../../assets/icons/Archivetest/edit.svg"
													alt=""
													@click="i.edit = true"
													class="pointer"
												/>
											</div>
										</div>
										<div v-else class="taggedtest-inputbox position-relative">
											<b-form-input style="width: 95%" v-model="i.cloneName">
											</b-form-input>
											<div class="taggedtickmark pointer">
												<img
													v-b-popover.hover.top="'Save'"
													src="../../assets/icons/Archivetest/tickmark.svg"
													alt=""
													@click="(i.name = i.cloneName), (i.edit = false)"
												/>
											</div>
											<div class="taggedclosemark pointer">
												<img
													v-b-popover.hover.top="'Cancel'"
													src="../../assets/icons/Archivetest/closexmark.svg"
													alt=""
													@click="(i.cloneName = i.name), (i.edit = false)"
												/>
											</div>
										</div>
									</div>
									<div style="width: 15%">
										<div class="d-flex align-items-center">
											<span class="archivesections-txt">Sections</span>
											<span class="archivegreennumbertext ml-2">{{
												i.numberOfSections
											}}</span>
										</div>
									</div>

									<div style="width: 15%" class="ml-3">
										<div class="d-flex align-items-center">
											<span class="archivesections-txt">Marks</span>
											<span class="archiveyellownumbertext ml-2">{{
												i.marks
											}}</span>
										</div>
									</div>
									<div
										v-if="failedTests.length > 1"
										style="width: 5%"
										class="d-flex justify-content-end pointer"
										@click="removeFailedTest(index)"
										v-b-popover.hover.top="'Delete'"
									>
										<img
											src="../../assets/icons/Archivetest/delete.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex justify-content-end align-items-center">
							<b-button
								class="addbtn mt-3 pl-3 pr-3"
								@click="(selectedTests = failedTests), tagTest()"
								:disabled="failedTests.length == 0"
								>Add</b-button
							>
						</div>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="ConfigExpiredModal"
				v-model="showExpiredModal"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
			>
				<div class="d-flex align-items-start">
					<div>
						<img src="../../assets/common-icons/warn-modal.svg" alt="" />
					</div>
					<div class="flex-1 pl-3">
						<div class="d-flex justify-content-between">
							<span class="font-lato fw-500 fs-18"
								>You are selecting an expired Configuration
							</span>
							<img
								@click="showExpiredModal = false"
								class="rotate-on-hover pointer"
								src="../../assets/common-icons/blue-cross.svg"
								alt=""
							/>
						</div>
						<div class="font-mont fs-13 fw-500 color-344054 mt-2">
							You have to edit the start and end date of the configuration to
							continue the selection
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-end pt-3 gap-3">
					<b-button
						@click="showExpiredModal = false"
						class="new-cancelBtn mt-1 "
						>Cancel</b-button
					>
					<b-button
						class="new-addBtn mt-1"
						@click="editUsingConfig(expiredConfigID)"
						>Edit</b-button
					>
				</div>
			</b-modal>
		</div>
		<AddConfigModal
			v-if="showAddConfigModal"
			:showModal="showAddConfigModal"
			:editConfigID="editConfigID"
			:viewConfigID="viewConfigID"
			@update-config="updateConfigValue"
			@change-selected-config="changeSelectedConfig"
			@close-modal="resetAll"
		/>
		<ViewAllConfigModal
			v-if="showViewConfigModal"
			:showModal="showViewConfigModal"
			:newConfigID="newConfigID"
			:updateConfig="updateConfig"
			:preSelectedConfigId="configId"
			:resetTrigger="resetTrigger"
			@close-modal="showViewConfigModal = false"
			@expired-warning="openExpiredModal"
			@post-config="postConfig"
			@add-config="addConfig"
			@edit-config="editUsingConfig"
			@view-config="viewConfig"
		/>
	</div>
</template>

<script>
import TestCard from "./cardview/testCard.vue";
import TestCardGrid from "./gridview/TestCardGrid.vue";
import SideTestConfig from "./SideTestConfig.vue";
import {
	getTestOrgPagination,
	getArchivedTest,
	postArchivedTest,
	getCategories,
	getSubCategories,
	getGatewayCharges,
} from "../../utils/apiFunctions";
import TestPreview from "./TestPreview.vue";
import { mapGetters, mapMutations } from "vuex";
import {
	required,
	maxLength,
	helpers,
	requiredIf,
	between,
	minValue,
} from "vuelidate/lib/validators";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import successToast from "../mixin/toast.js";
import errorToast from "../mixin/toast";
import AddConfigModal from "@/components/modals/AddConfigModal.vue";
import ViewAllConfigModal from "@/components/modals/ViewAllConfigModal.vue";
const maxFiveDecimals = helpers.withParams(
	{ type: "maxFiveDecimals" },
	(value) => {
		if (!helpers.req(value)) return true;

		const str = value.toString();
		if (!str.includes(".")) return true;

		return str.split(".")[1].length <= 5;
	}
);
export default {
	name: "Tests",
	mixins: [successToast, errorToast],
	components: {
		TestCard,
		TestCardGrid,
		SideTestConfig,
		TestPreview,
		Spinner,
		AddConfigModal,
		ViewAllConfigModal,
	},
	data() {
		return {
			addAssessLb: false,
			openLeaderBoardDropdown: false,
			leaderBoardoptions: [
				{
					value: "technical",
					text: "Technical",
				},
				{
					value: "nontechnical",
					text: "Non-Technical",
				},
				{
					value: "communication",
					text: "Communication",
				},
			],
			resetTrigger: null,
			updateConfig: false,
			expiredConfigID: "",
			viewConfigID: "",
			editConfigID: "",
			newConfigID: "",
			configName: "",
			configId: null,
			showExpiredModal: false,
			setConfiguration: "auto",
			showViewConfigModal: false,
			showAddConfigModal: false,
			filtertestFix: "",
			totalPages: null,
			showtestaddoptions: false,
			testCardselected: "Active",
			sortColumn: "createdAt",
			sortoptions_selected: "",
			name: "",
			totalTests: 0,
			page: 0,
			count: 20,
			activeForTest: 1,
			sort_selected: 4,
			sortorder: -1,
			filtercount: 0,
			testnum: 1,
			selectedTests: [],
			tests: [],
			failedTests: [],
			search: "",
			goToTestPage: null,
			totalTest: null,
			testPageStart: null,
			testPageEnd: null,
			selectall: false,
			showTestSpinner: false,
			testCount: 50,
			currentTestPage: 1,
			testType: 1,
			updateData: null,
			force: null,
			active: true,
			showLoader: true,
			showtestcard: false,
			showfiltercard: false,
			showsortcard: false,
			cardSelectedForActivate: false,
			showAddNewCardWhenNoData: false,
			publicAvailability: false,
			LoaderStatus: false,
			selectFirstCard: {},
			testState: [],
			filter: {
				// protunprot: "",
				publicAvailability: "",
				section: "",
			},
			storefilterdata: {
				publicAvailability: "",
				section: "",
			},
			selectedtest: {},
			test: {
				id: 0,
				name: "",
			},
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
			setConfigOptions: [
				{
					item: "auto",
					name: "Auto",
				},
				{
					item: "manual",
					name: "Manual",
				},
			],
			activetest: [],
			updatedataoptions: [
				{
					item: false,
					name: "Activate the Test",
				},
				{
					item: true,
					name: "Add New Test",
				},
			],
			difficultyoptions: [
				{
					value: "E",
					text: "Easy",
				},
				{
					value: "M",
					text: "Medium",
				},
				{
					value: "H",
					text: "Hard",
				},
			],
			sort_options: [
				{ text: "Test(Asc)", value: "1" },
				{ text: "Test(Desc)", value: "2" },
				{ text: "Date Created(Asc)", value: "3" },
				{ text: "Date Created(Desc) (Default)", value: "4" },
				{ text: "Date Modified(Asc)", value: "5" },
				{ text: "Date Modified(Desc)", value: "6" },
			],
			testTypeOptions: [
				{ text: "All", value: "2" },
				{ text: "Active", value: "1" },
				{ text: "Inactive", value: "0" },
			],

			openCategoryDropdown: false,
			selectedCategory: null,
			selectedLbOption: null,
			openSubCategoryDropdown: false,
			selectedSubCategory: null,
			listPrice: null,
			discount: null,
			setPricing: false,
			gatewayPercent: 0,
			gatewayConfig: {},
		};
	},
	validations: {
		name: {
			required,
			maxLength: maxLength(128),
			alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
		},
		selectedCategory: { required },
		selectedSubCategory: { required },

		listPrice: {
			required: requiredIf(function() {
				return this.setPricing;
			}),
			maxFiveDecimals,
			between: between(0, 100000),
		},

		discount: {
			minValue: minValue(0),
			maxFiveDecimals,
			notGreaterThanList: helpers.withParams(
				{ type: "notGreaterThanList" },
				function(value) {
					// IMPORTANT: skip validation if empty
					if (!helpers.req(value)) return true;

					return Number(value) < Number(this.listPrice);
				}
			),
		},

		selectedLbOption: {
			required: requiredIf(function() {
				return this.addAssessLb;
			}),
		},
	},
	mounted() {
		const el = document.getElementById("top1");
		const el1 = document.getElementById("top1config");
		el.addEventListener("click", this.simple, false);
		el1.addEventListener("click", this.simple, false);
	},
	created() {
		this.LoaderStatus = true;
		this.$store.commit("searchVUEX/saveSearchTopicTest", "");
		this.$store.commit("testVUEX/saveshowPreviewTest", {
			preview_status: false,
		});
		// Managing tab redirect based on Test type and Sort
		this.tabRedirect();
		this.testConfigData.testID = "";

		this.getCategories();
		this.getSubCategories();
		this.getGatewayCharges();
		console.log(" leaderboardAdminAccess", this.leaderboardAdminAccess);
	},
	watch: {
		setConfiguration() {
			this.configName = "";
			this.configId = null;
		},
		selectedCategory() {
			this.selectedSubCategory = null;
		},
		searchTopicTest(newValue, oldValue) {
			if (newValue != oldValue) {
				this.resetPagination();
			}
		},
		testConfigData() {
			this.selectFirstCard = this.testConfigData;
		},

		// Watch for these variables for Tab Redirect
		testCardselected() {
			this.$router.push({
				name: `Tests`,
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
					ttype: this.testCardselected,
					tsort: this.sort_selected,
				},
			});
		},
		sort_selected() {
			this.$router.push({
				name: `Tests`,
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
					ttype: this.testCardselected,
					tsort: this.sort_selected,
				},
			});
		},
	},
	computed: {
		priceAfterDiscount() {
			if (!this.listPrice) return 0;
			return this.listPrice - (this.discount || 0);
		},

		gatewayAmount() {
			return (this.priceAfterDiscount * this.gatewayPercent) / 100;
		},

		finalReceivable() {
			return this.priceAfterDiscount - this.gatewayAmount;
		},

		clearFilterclass() {
			return (
				this.filter.publicAvailability === "" &&
				this.filter.section.toString().length == 0
			);
		},
		...mapGetters("testVUEX", {
			testConfigStatus: "getTestConfigStatus",
			testConfigData: "getTestConfigData",
			showTestPreviewStatus: "getShowTestPreviewStatus",
			categories: "getCategories",
			subCategories: "getSubCategories",
		}),
		...mapGetters("searchVUEX", {
			list: "getListView",
			grid: "getGridView",
			switchviews: "getToggleView",
			searchTopicTest: "getSearchTopicTest",
		}),
		...mapGetters("userVUEX", {
			leaderboardAdminAccess: "getleaderboardAdminAccess",
		}),
		...mapGetters(["roles"]),
		isEmpty() {
			let temp;
			if (this.searchTopicTest == "") {
				temp = false;
			} else if (this.searchTopicTest != "" && this.testState.length == 0) {
				temp = true;
			}
			if (
				this.storefilterdata.publicAvailability !== "" ||
				this.storefilterdata.section !== ""
			) {
				if (this.testState.length === 0) {
					temp = true;
				}
			}

			return temp;
		},
		isContainsNumber() {
			return !/^\d+$/.test(this.goToPage);
		},
	},

	methods: {
		hideshowPricingDetails() {
			if (this.setPricing) {
				this.discount = 0;
			} else {
				this.listPrice = null;
				this.discount = null;
			}
		},
		getDeviceMode() {
			const ua = navigator.userAgent || navigator.vendor || window.opera;

			if (/android/i.test(ua)) return "ANDROID";

			if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "IOS";

			if (/Mobi|Mobile/.test(ua)) return "MOBILE_WEB";

			return "WEB";
		},

		async getGatewayCharges() {
			try {
				const res = await getGatewayCharges();

				if (res.status == 200) {
					this.gatewayConfig = res.data.data.HIRE3X_FEE;

					const deviceMode = this.getDeviceMode();

					const feeObj = Object.values(this.gatewayConfig).find(
						(f) => f.mode === deviceMode
					);

					this.gatewayPercent = feeObj?.charge || 0;
				}
			} catch (error) {
				console.error(error);
			}
		},
		updateConfigValue() {
			this.updateConfig = true;
		},
		resetAll() {
			this.viewConfigID = "";
			this.editConfigID = "";
			this.resetTrigger = Date.now();
			this.showAddConfigModal = false;
		},
		viewConfig(data) {
			this.viewConfigID = data;
			this.showAddConfigModal = true;
		},
		editUsingConfig(data) {
			this.viewConfigID = "";
			this.editConfigID = data;
			this.showAddConfigModal = true;
			this.showExpiredModal = false;
		},
		changeSelectedConfig(data) {
			console.log("the data is", data);
			this.newConfigID = data;
		},
		addConfig() {
			this.showAddConfigModal = true;
		},
		openExpiredModal(data) {
			this.showExpiredModal = true;
			this.expiredConfigID = data.configID;
		},
		async getCategories() {
			try {
				const res = await getCategories();
				if (res.status == 200) {
					this.$store.commit("testVUEX/saveCategories", res.data.data);
				} else {
					throw new Error("Failed to fetch categories");
				}
			} catch (error) {
				console.error(error);
				this.categories = [];
			}
		},
		async getSubCategories() {
			try {
				const res = await getSubCategories();
				if (res.status == 200) {
					this.$store.commit("testVUEX/saveSubCategories", res.data.data);
				} else {
					throw new Error("Failed to fetch sub categories");
				}
			} catch (error) {
				console.error(error);
				this.subCategories = [];
			}
		},
		closeCategoryDropdown() {
			this.openCategoryDropdown = false;
		},
		closeLeaderBoardDropdown() {
			this.openLeaderBoardDropdown = false;
		},
		closeSubCategoryDropdown() {
			this.openSubCategoryDropdown = false;
		},
		handleFilterClick() {
			this.filtercount === 0 ? this.clearfilterbox() : this.clearfilter();
		},

		toggleDropdown() {
			this.showtestaddoptions = !this.showtestaddoptions;
			if (this.showtestaddoptions) {
				document.addEventListener("click", this.closeDropdown);
			} else {
				document.removeEventListener("click", this.closeDropdown);
			}
		},
		closeDropdown(event) {
			if (!this.$refs.dropdown.contains(event.target)) {
				this.showtestaddoptions = false;
				document.removeEventListener("click", this.closeDropdown);
			}
		},
		avoidLetterE(event) {
			const key = event.key;
			const maxLength = 3;
			const hasDecimal = this.filter.section.includes(".");
			const numbersRegex = /^\d+$/;
			if (
				key.toLowerCase() === "e" ||
				hasDecimal ||
				key === "." ||
				this.filter.section.length >= maxLength ||
				!numbersRegex.test(key)
			) {
				event.preventDefault();
			}
		},

		...mapMutations("searchVUEX", {
			saveToggleView: "saveToggleView",
		}),
		// Managing tab redirect based on Test type and Sort
		tabRedirect() {
			if (this.$route.query.tsort || this.$route.query.ttype) {
				this.sort_selected = this.$route.query.tsort;
				this.testCardselected = this.$route.query.ttype;
				this.changeSort();
				return;
			}
			this.clearfilter();
		},
		selected() {
			this.cardSelectedForActivate = true;
		},
		goTobackpage() {
			this.$router.push({
				name: "Home",
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
				},
			});
		},
		resetPagination() {
			this.testState = [];
			this.page = 0;
			this.showLoader = false;
			this.LoaderStatus = true;
			this.getTests(true);
		},
		lengthofTotalTopicsWhenedidted(data, cloneData) {
			this.testState[data].name = cloneData.name;
			this.testState[data].description = cloneData.description;
			this.testState[data].publicAvailability = cloneData.publicAvailability;
			this.getTests();
		},
		onScroll(e) {
			// Get the target element of the scroll event.
			const { target } = e;
			// Check if the user has reached the bottom of the scrollable area.
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				// Check if there is more data to load.
				if (this.checkbetween(this.pageEnd, 0, this.totalTests)) {
					this.page++;
					this.getTests();
				}
			}
		},
		checkbetween(x, min, max) {
			return x > min && x < max;
		},

		async getTests() {
			try {
				let payload = this.buildPayload();
				let res = await getTestOrgPagination(payload);
				this.handleResponse(res);
			} catch (error) {
				this.LoaderStatus = false;
				throw error;
			}
		},
		openViewAllConfigModal() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.showViewConfigModal = true;
			}
		},
		buildPayload() {
			let payload = {
				topicID: this.$route.params.topicID,
				searchQuery: this.searchTopicTest,
				sortBy: this.sortColumn,
				order: this.sortorder,
				publicAvailability: this.filter.publicAvailability,
				sections: this.filter.section,
				type: this.activeForTest,
				page: this.page,
				count: this.count,
				setPricing: this.setPricing,
			};
			if (this.setPricing) {
				payload.pricingDetails = {
					pricingType: 1,
					discountAmount: this.discount,
					listPrice: this.listPrice,
					finalPrice: this.finalReceivable,
				};
			}
			this.cleanPayload(payload);

			return payload;
		},

		cleanPayload(payload) {
			if (payload.sortBy == null) {
				delete payload.sortBy;
				delete payload.order;
			}
			if (payload.publicAvailability == null) {
				delete payload.publicAvailability;
			}
			if (payload.sections.toString().length == 0) {
				delete payload.sections;
			}
			if (payload.searchQuery == "") {
				delete payload.searchQuery;
			}
		},
		handleResponse(res) {
			if (res.status == 200) {
				if (res.data.data.testIDs.length !== 0) {
					this.updateTestState(res.data.data.testIDs);
				}
				this.updateUIStatus(res.data.data);
				this.LoaderStatus = false;
			}
		},

		updateTestState(testIDs) {
			if (this.page == 0) {
				this.testState = testIDs.map((data) => {
					return { ...data, editoption: false };
				});
			} else {
				let data = testIDs.map((data) => {
					return { ...data, editoption: false };
				});
				this.testState = [...this.testState, ...data];
			}
		},

		updateUIStatus(data) {
			this.showLoader = data.total !== data.pageEnd;
			this.totalTests = data.total;
			this.pageEnd = data.pageEnd;
			this.showAddNewCardWhenNoData = data.total === 0;

			if (data.testIDs.length === 0 || this.testCardselected === "Inactive") {
				this.selectFirstCard = {};
			}
		},

		// Making inactive in to active
		gotoparticularpage() {
			if (!this.updateData) {
				this.LoaderStatus = false;
				this.$bvModal.show("inactivetests");
			} else {
				this.LoaderStatus = false;
				this.test.force = true;
				this.$bvModal.show("testNameModal");
				this.$bvModal.hide("testsamename");
			}
		},
		//Making inactive  in to active
		gotoparticulartestdetails() {
			this.selectedtest.topicID = this.$route.params.topicID;
			this.$bvModal.hide("testsamename");
			this.selectedtest.active = true;
			this.selectedtest.force = true;
			this.$store
				.dispatch("testVUEX/saveTest", this.selectedtest)
				.then((res) => {
					if (res.status == 200) {
						this.resetPagination();
						this.clearTestModalData();
						this.successToast("Test activated successfully!");
						this.$bvModal.hide("inactivetests");
					} else {
						this.errorToast("Something went wrong!");
					}
				})
				.catch((err) => {
					this.errorToast("Something went wrong!");
					throw err;
				});
		},
		//Making inactive  in to active
		makeactive() {
			// Start with addtest-like payload
			let testPayload = {
				topicID: this.$route.params.topicID,
				name: this.name,
				portion: "Test",
				testID: this.testnum,
				publicAvailability: this.publicAvailability,
				categoryID: this.selectedCategory,
				subCategoryID: this.selectedSubCategory,
				active: this.active,
				force: false, // 👈 extra for makeactive
			};

			if (this.setConfiguration === "manual") {
				testPayload.configID = this.configId;
			}

			this.test = testPayload;

			this.$store
				.dispatch("testVUEX/saveTest", this.test)
				.then((res) => {
					if (res.status == 200) {
						this.$bvModal.hide("testNameModal");
						this.clearTestModalData();
						this.showtestaddoptions = false;
						this.successToast("New Test Created Successfully!");
						this.getTests();
					} else if (res.status == 409) {
						this.activetest = res.data.data.tests;
						this.$bvModal.show("testsamename");
					} else if (res.status == 404) {
						this.errorToast(res.data.data.Data);
					}
				})
				.catch((err) => {
					this.errorToast("Something went wrong!");
					throw err;
				});
			this.$bvModal.hide("testsamename");
		},
		testFunction() {
			this.showtestcard = !this.showtestcard;
			this.$forceUpdate();
		},
		hideTestFunction() {
			this.showtestcard = false;
		},
		sortFunction() {
			this.showsortcard = !this.showsortcard;
			this.$forceUpdate();
		},
		hideSortFunction() {
			this.showsortcard = false;
		},
		filterFunction() {
			this.filter = { ...this.storefilterdata };
			this.showfiltercard = !this.showfiltercard;
			this.$forceUpdate();
		},
		hideFilterFunction() {
			this.filter.section = this.filtertestFix;
			this.showfiltercard = false;
		},
		simple() {
			this.showtestcard = false;
			this.showfiltercard = false;
			this.showsortcard = false;
		},
		testcardoptions(data) {
			for (let i in this.testState) {
				this.testState[i].editoption = false;
				if (this.testState[i].testID == data) {
					this.testState[i].editoption = true;
				}
			}
		},
		changevalue(data) {
			for (let i in this.testState) {
				if (this.testState[i].testID == data) {
					this.testState[i].editoption = false;
				}
			}
		},
		// Function to display data based on Sort and Test type
		changeSort() {
			if (this.sort_selected == "1") {
				this.sortColumn = "name";
				this.sortorder = 1;
			} else if (this.sort_selected == "2") {
				this.sortColumn = "name";
				this.sortorder = -1;
			} else if (this.sort_selected == "3") {
				this.sortColumn = "createdAt";
				this.sortorder = 1;
			} else if (this.sort_selected == "4") {
				this.sortColumn = "createdAt";
				this.sortorder = -1;
			} else if (this.sort_selected == "5") {
				this.sortColumn = "updatedAt";
				this.sortorder = 1;
			} else {
				this.sortColumn = "updatedAt";
				this.sortorder = -1;
			}
			if (this.testCardselected == "Active") {
				this.activeForTest = 1;
			} else if (this.testCardselected == "Inactive") {
				this.activeForTest = 0;
			} else {
				this.activeForTest = 2;
			}

			this.resetPagination();
			this.showsortcard = false;
			this.showtestcard = false;
		},
		applyfilter() {
			this.storefilterdata = { ...this.filter };
			this.filtercount = 0;
			if (this.filter.section.toString().length > 0) {
				this.filtercount++;
			}
			if (this.filter.publicAvailability !== "") {
				this.filtercount++;
			}
			this.resetPagination();
			this.filtertestFix = this.filter.section;
			this.showfiltercard = false;
		},
		async archivetestmodal() {
			this.showTestSpinner = true;
			this.$bvModal.show("archivetestmodal");
			try {
				let payload = {
					type: this.testType,
					searchQuery: this.search,
					topicID: this.$route.params.topicID,
					sortBy: {
						column: "createdAt",
						order: false,
					},
					count: this.testCount,
					page: this.currentTestPage - 1,
				};
				const res = await getArchivedTest(payload);
				if (res.status == 200) {
					this.tests = res.data.data.data;
					console.log("this test", this.tests);

					this.totalTest = res.data.data.total;
					this.testPageEnd = res.data.data.pageEnd;
					this.testPageStart = res.data.data.pageStart;
					this.showTestSpinner = false;
					this.totalPages = Math.ceil(
						parseInt(this.totalTest) / parseInt(this.testCount)
					);
				}
				this.checkSelectAll();
			} catch (error) {
				console.log(error);
			}
		},
		goToTopicPageNo(index) {
			this.currentTestPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToTestPage = null;
			this.archivetestmodal();
		},
		selectAll() {
			if (this.selectall) {
				for (let i in this.tests) {
					if (
						this.selectedTests.filter(
							(value) => value.testID == this.tests[i].testID
						).length === 0
					) {
						let newTest = {
							testID: this.tests[i].testID,
							name: this.tests[i].testName,
							publicAvailability: this.tests[i].publicAvailability,
							numberOfSections: this.tests[i].numberOfSections,
							candidateCount: this.tests[i].candidateCount,
							marks: this.tests[i].marks,
							categoryID: this.tests[i].categoryID,
							subCategoryID: this.tests[i].subCategoryID,
						};

						// ✅ Add leaderboard fields if admin access is true
						if (
							this.leaderboardAdminAccess &&
							(!("leaderboard" in newTest) ||
								!("leaderboardCategory" in newTest))
						) {
							newTest.leaderboard = this.tests[i].leaderboard;
							newTest.leaderboardCategory = this.tests[i].leaderboardCategory;
						}

						this.selectedTests.push(newTest);
					}
				}
			} else {
				for (let j in this.tests) {
					if (
						this.selectedTests.filter(
							(value) => value.testID == this.tests[j].testID
						).length > 0
					) {
						let index = this.selectedTests.findIndex(
							(x) => x.testID == this.tests[j].testID
						);
						this.selectedTests.splice(index, 1);
					}
				}
			}
		},
		containsAllObjects(mainArray, subArray) {
			return subArray.every((subObj) => {
				return mainArray.some((mainObj) => {
					// Compare objects using a unique identifier property
					return mainObj.testID == subObj.testID;
				});
			});
		},
		deselect() {
			this.selectall = false;
			const containsAll = this.containsAllObjects(
				this.selectedTests,
				this.tests
			);
			if (containsAll) {
				this.selectall = true;
			}
		},
		checkSelectAll() {
			let isSelectedAll = true;

			if (this.tests.length === 0) {
				isSelectedAll = false;
			} else {
				for (const record of this.tests) {
					if (
						this.selectedTests.filter((value) => value.testID === record.testID)
							.length === 0
					) {
						isSelectedAll = false;
					}
				}
			}

			this.selectall = isSelectedAll;
		},

		async tagTest() {
			console.log(this.selectedTests, "fghjnkm");
			try {
				let payload = {
					topicIDs: [],
					testIDs: this.selectedTests,
					failCheck: true,
				};
				payload.topicIDs.push(this.$route.params.topicID);
				const res = await postArchivedTest(payload);
				if (res.status == 200) {
					this.failedTests = res.data.data.unsuccessful;
					this.failedTests = this.failedTests.map((data) => {
						return {
							...data,
							edit: false,
							cloneName: data.name,
						};
					});
					if (this.failedTests.length > 0) {
						this.$bvModal.hide("archivetestmodal");
						this.$bvModal.hide("testNameModal");
						this.$bvModal.show("taggedfailtest");
					} else {
						this.$bvModal.hide("archivetestmodal");
						this.$bvModal.hide("taggedfailtest");
						this.resetPagination();
						this.$bvModal.hide("testNameModal");
						this.successToast("Selected tests tagged successfully");
					}
				}
				if (res.status == 409) {
					this.failedTests = this.selectedTests;
					this.failedTests = this.failedTests.map((data) => {
						return {
							...data,
							edit: false,
							cloneName: data.name,
						};
					});
					if (this.failedTests.length > 0) {
						this.$bvModal.hide("archivetestmodal");
						this.$bvModal.hide("testNameModal");
						this.$bvModal.show("taggedfailtest");
					}
				}
			} catch (error) {
				console.log(error);
			}
			this.showTestSpinner = false;
		},
		removeFailedTest(index) {
			this.failedTests.splice(index, 1);
		},
		modalpop() {
			this.showfiltercard = !this.showfiltercard;
			this.showsortcard = false;
			this.showtestcard = false;
		},
		clearfilterbox() {
			this.filter.publicAvailability = "";
			this.filter.section = "";
			this.filtertestFix = "";
			this.filtercount = 0;
			this.showfiltercard = true;
			this.resetPagination();
		},
		clearfilter() {
			this.filter = {
				publicAvailability: "",
				section: "",
			};
			this.storefilterdata = {
				publicAvailability: "",
				section: "",
			};
			this.filtertestFix = "";
			this.resetPagination();
			this.filtercount = 0;
			this.showfiltercard = false;
		},
		addtest() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				// PRIORITY: negative discount check
				if (this.$v.discount.$dirty && !this.$v.discount.minValue) {
					this.errorToast("Please don’t enter a negative number");
					return;
				}
				if (
					(this.$v.discount.$dirty && !this.$v.discount.maxFiveDecimals) ||
					(this.$v.listPrice.$dirty && !this.$v.listPrice.maxFiveDecimals)
				) {
					this.errorToast(
						"Please enter a valid price with up to 5 decimal places"
					);
					return;
				}

				// next: discount > listPrice
				if (!this.$v.discount.notGreaterThanList) {
					this.errorToast(
						"Discount cannot be greater or equal than list price"
					);
					return;
				}

				// default
				this.errorToast("Please fill all the mandatory fields");
				return;
			}
			if (this.$v.$invalid) {
				this.errorToast("Please fill all the mandatory fields");
			} else {
				this.testnum += 1;

				let testPayload = {
					topicID: this.$route.params.topicID,
					name: this.name,
					portion: "Test",
					testID: this.testnum,
					publicAvailability: this.publicAvailability,
					categoryID: this.selectedCategory,
					subCategoryID: this.selectedSubCategory,
					active: this.active,
					candidateCount: 0,
					marks: 0,
					numberOfSections: 0,
					editoption: false,
					autoCorrection: false,
					isLocked: false,
					setPricing: this.setPricing,
					pricingDetails: {
						pricingType: 1,
						discountAmount: this.discount,
						listPrice: this.listPrice,
					},
				};

				// ✅ add configID only if manual
				if (this.setConfiguration === "manual") {
					testPayload.configID = this.configId;
				}

				// add leaderboard fields if admin access and key are present
				if (
					this.leaderboardAdminAccess &&
					(!("leaderboard" in testPayload) ||
						!("leaderboardCategory" in testPayload))
				) {
					testPayload.leaderboard = this.addAssessLb;
					testPayload.leaderboardCategory = this.selectedLbOption;
				}

				this.test = testPayload;

				this.$v.$reset();

				let data = {
					topicName: this.$route.params.topicName,
					topicID: this.$route.params.topicID,
				};
				this.$store.commit("topicVUEX/saveSelectedTopic", data);

				this.$store
					.dispatch("testVUEX/saveTest", this.test)
					.then((res) => {
						if (res.status == 200) {
							this.showtestaddoptions = false;
							this.configId = null;
							this.configName = "";
							this.setConfiguration = "auto";
							this.successToast("New test created successfully!");
							document.getElementById("headerSearch").value = "";
							this.$store.commit("searchVUEX/saveSearchTopicTest", "");
							this.clearTestModalData();
							this.resetPagination();
							this.$bvModal.hide("testNameModal");
						} else if (res.status == 409) {
							this.activetest = res.data.data.tests;
							this.$bvModal.show("testsamename");
							this.$bvModal.hide("testNameModal");
						} else if (res.status == 208) {
							this.errorToast(`The test name already exists`);
						} else if (res.status == 404) {
							this.$bvModal.hide("testNameModal");
							this.errorToast(res.data.data.Data);
						} else {
							this.$bvModal.hide("testNameModal");
							this.errorToast("Something went wrong!");
						}
					})
					.catch((err) => {
						this.errorToast("Something went wrong!");
						this.$bvModal.hide("testNameModal");
						this.clearTestModalData();
						throw err;
					});
			}
		},

		postConfig(config) {
			this.configId = config.configID;
			this.configName = config.configName;
			this.showViewConfigModal = false;
		},
		closetestmodal() {
			this.$bvModal.hide("testNameModal");
			this.clearTestModalData();
		},
		clearTestModalData() {
			this.name = "";
			this.publicAvailability = false;
			this.selectedCategory = null;
			this.selectedSubCategory = null;
			this.configId = null;
			this.configName = "";
			this.setConfiguration = "auto";
			this.updateData = null;
			this.selectedtest = {};
			this.addAssessLb = false;
			this.selectedLbOption = null;
			delete this.test.force;
			this.setPricing = false;
			this.listPrice = null;
			this.discount = null;
			this.$v.$reset();
		},
	},
};
</script>
<style>
.bct-content-heading {
	font-weight: 500;
	font-size: 14px;
	color: #72738e;
}

.viewcon-select:focus {
	border: 1px solid #d0d5dd;
}

.viewcon-select:hover {
	border: 1px solid #d0d5dd;
}

.viewcon-select:active {
	border: 1px solid #d0d5dd;
}

.viewcon-select {
	background: #fdfdfd;
	border: 1px solid #d0d5dd;
	border-radius: 8px;
	color: #6d6d6d;
	font-size: var(--size-13);
	height: 40px;
	cursor: pointer;
	padding: 0.58rem 0.75rem 0.375rem 0.75rem;
	align-items: center;
}
.viewcon-select .viewcon-option-clr {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}
.viewcon-label {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #667085;
	background-color: var(--bg-inputfield);
	position: absolute;
	left: 9px;
	top: -12px;
	z-index: 4;
	padding: 0px 7px;
}

.bct-od-ev:nth-child(odd) {
	background: #f4f4f4;
}

.bct-od-ev:nth-child(even) {
	background: #fdfdfd;
}

.bct-checkboxcontainer {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
	overflow-y: auto;
	width: 100%;
	position: absolute;
	z-index: 5;
}

.bct-checboxtext {
	font-weight: 400;
	font-size: 14px;
	color: #545454;
}

.qb-dd-group-ct .btn {
	text-align: left;
}

.radio-drp-dwn .btn-secondary {
	background-color: #fcfcfc;
	border: none;
	font-size: 14px;
	color: #696969;
}

.configpreviewgraphval {
	margin-top: 5rem;
}
.taggedtickmark {
	position: absolute;
	right: 65px;
	top: 5px;
}
.taggedclosemark {
	position: absolute;
	right: 35px;
	top: 5px;
}
.taggedtest-inputbox .form-control {
	background: #f2f2f2;
	border: 1px solid #f2f2f2;
	border-bottom: 2px solid #3379b3;
	border-radius: unset;
	font-weight: 600;
	font-size: 14px;
	color: #1a4164;
	padding: 10px 70px 10px 10px;
}
.taggedtest-inputbox .form-control:focus {
	border: none !important;
	box-shadow: none !important;
}
.taggedtest-text {
	font-weight: 400;
	font-size: 14px;
	color: #8a8b8c;
}
#archivetestmodal .modal-body {
	min-height: auto;
	max-height: calc(100vh - 125px);
}
.tests-paginaTion {
	width: 100%;
	padding: 5px 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 2px 2px;
	background: #f2f4fd;
	z-index: 1;
}
.archivesections-txt {
	font-weight: 400;
	font-size: 13px;

	color: #696969;
}
.archivegreennumbertext {
	font-weight: 500;
	font-size: 14px;

	color: #038e00;
}
.archivebluenumbertext {
	font-weight: 500;
	font-size: 14px;

	color: #84a3fe;
}
.archiveyellownumbertext {
	font-weight: 500;
	font-size: 14px;

	color: var(--cv-yellow);
}
.archivetest-list-cards {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: 80px;
	position: relative;
}

.no-archivetest-list-cards {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: calc(100vh - 431px);
	position: relative;
}
.archivelist-topictxt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.archivelist-testtxt {
	font-weight: 600;
	font-size: 14px;
	color: #1a4164;
	width: 80%;
}
.archivetestcheckbox .custom-control-label::before {
	/* background-color: #eef2f5; */
	border-radius: 2px;
	top: 2px;
}
.archivetestcheckbox .custom-control-label::after {
	top: 2px;
}
.archivetestcheckbox .custom-control-label {
	position: relative;
	margin-bottom: 0;
	vertical-align: top;
	font-weight: 500;
	font-size: 14px;

	color: #696969;
}
.tabbed .nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
	border-color: #e9ecef #e9ecef #dee2e6;
}
.tabbed ul li a:before {
	top: -2px;
	height: 110%;
}
</style>
<style>
.test-options-text {
	font-weight: 400;
	font-size: 13px;
	color: #545454;
}
.test-optionscard {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
	padding: 10px 9px;
	position: absolute;
	top: 96px;
	z-index: 2;
}
.tnt-sortcard .custom-control {
	padding-left: 2rem !important;
	padding-top: 5px;
	padding-bottom: 5px;
}
.sort-radio:nth-child(even) {
	background: #fdfdfd;
}
.sort-radio:nth-child(odd) {
	background: #f4f4f4;
}
.test-activate-options-text {
	color: #696969;
	font-weight: 500;
}
.test-heading {
	color: #464667;
	font-size: 18px;
	font-weight: 600;
	margin-left: 15px;
}

.test-sortcontainer {
	background: #fcfcfc;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px 15px;
}

.jdtyperadio:nth-child(odd) {
	background: #f4f4f4;
}

.jdtyperadio:nth-child(even) {
	background: #fdfdfd;
}

.sorttext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
}

.sortline {
	width: 0px;
	height: 19px;
	border: 1px solid #c4c4c4;
	background: #c4c4c4;
}

.sortordertext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
}

.flip-list-move {
	transition: transform 1s;
}

.cell:nth-child(3n) {
	margin-right: 0;
}

.cell:nth-child(27n) {
	margin-bottom: 0;
}
.tp-testdiv {
	position: relative;
	height: calc(100vh - 80px);
	top: 80px;
	padding-left: 80px;
	padding-right: 15px;
	overflow: hidden;
}

.cell-move {
	transition: transform 1s;
}

.testsamename-modal-text {
	font-weight: 400;
	font-size: 14px;
	color: #8a8b8c;
}

.testsamename-test {
	color: #3471cd;
}

.testdata-size {
	height: 380px;
	overflow: auto;
}

.inactive-selected-box {
	background: #e2e7fd;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.3);
	border-radius: 5px;
	color: #696969;
	margin: 5px;
	padding: 10px;
}

.inactivecust-detail-box {
	background: #fcfcfc;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	color: #696969;
	margin: 5px;
	padding: 10px;
}

.flexgrid {
	display: flex;
	place-content: flex-start;
	justify-content: space-around;
}

.tp-gridcont {
	display: flex;
}

.tp-gridcard {
	background: #fbfbfb;
	border: 0.7px solid var(--bg-backgroundcolor);
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	height: 0px;
	padding: 15px;
}

.sort-box {
	border: 1px solid #72738e;
	padding: 5px 8px;
	border-radius: 3px;
}

.heading-container {
	position: relative;
	z-index: 1;
}
.heading-container::before {
	content: "";
	display: inline-block;
	position: absolute;
	width: 27px;
	height: 20px;
	top: 3px;
	left: -11px;
	z-index: -1;
	background: var(--cv-yellow);
	-moz-border-radius: 10px;
	-webkit-border-radius: 10px;
	border-radius: 50%;
}
.filter-box {
	border: 1px solid #72738e;
	padding: 5px;

	border-radius: 3px;
}

.boxtext {
	font-weight: var(--weight-M);
	font-size: var(--size-18);

	color: var(--headtext) !important;
}

.t-test-container {
	width: 240px;
}
.test-caution-option {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
}

.qb-filter-count {
	width: 19px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding-top: 2px;
	padding-left: 6px;
	position: absolute;
	top: -5px;
	right: -15px;
}

.emptyillusttext {
	font-size: 12px;
	font-weight: 400;
	color: #696969;
}
.selected-config {
	background-color: #f7f9fb;
	border-radius: 8px;
	padding: 10px 16px;
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 12px;
	flex: 1;
}

#testConfg .custom-control-label,
#testNameModal .custom-control-label {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 16px !important;
	color: #344054;
}

#testConfg .modal-body,
#testNameModal .modal-body {
	padding: 0;
}
.new-tp-pading {
	padding: 10px;
}
.viewicon-select-disable {
	background: #e4e4e5 !important;
}
.test-disable-color {
	background: rgba(140, 140, 140, 0.15) !important;
	border: 1px solid #d0d5dd !important;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05) !important;
	border-radius: 8px !important;
	opacity: unset !important;
	cursor: not-allowed;
}
</style>
